// extracted by mini-css-extract-plugin
export var colOne = "styles-module--colOne--a62e0";
export var colTwo = "styles-module--colTwo--f2b38";
export var title = "styles-module--title--7edf1";
export var twoColumnTable = "styles-module--twoColumnTable--6e4cb";
export var twoColumnTableContainer = "styles-module--twoColumnTableContainer--df38f";
export var twoColumnTableDiv = "styles-module--twoColumnTableDiv--ce055";